export * from './riskfactorClasses.component';
export * from './riskfactorClassForm.component';
export * from './riskfactorClassResolver';

